import { Badge, ButtonBase } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import usePrevious from '../../../../../Hooks/usePrevious';
import useSessionContext from '../../../../LiveContext/SessionContextProvider/useSessionContext';
import useDetectionGroups from '../../Contexts/DetectionGroupContext/useDetectionGroups';
import StyledBox from './styles';

function UpdateBadge(props: { children: React.ReactNode, seenAt: number, badgeContent: number, updatedAt?: number, disabled?: boolean }) {
  const {
    children, seenAt, updatedAt, disabled, badgeContent,
  } = props;
  if (!updatedAt || disabled) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }
  if (updatedAt > seenAt) {
    return (
      <Badge badgeContent={badgeContent} color="error" variant="standard" anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
        {children}
      </Badge>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

export default function PanelTabs(props: { index: number, setIndex: (value: number) => void, updatedAt: number }) {
  const {
    index, setIndex, updatedAt,
  } = props;
  const { latestDetection, compliance, session } = useSessionContext();
  const { t } = useTranslation();
  const [initialized, setInitialised] = React.useState(false);
  const previousComplianceLength = usePrevious(compliance.length);
  const allDetections = useDetectionGroups();

  const unseenDetections = React.useMemo(() => allDetections.filter((detectionGroup) => !!detectionGroup.notificationBadge && !detectionGroup.notificationBadge.seen), [allDetections]);

  React.useEffect(() => {
    if (!session) {
      setInitialised(false);
    }
  }, [!!session]);

  React.useEffect(() => {
    if (compliance.length && !initialized) {
      setIndex(1);
      setInitialised(true);
    } else if (compliance.length > previousComplianceLength && index !== 1) {
      setIndex(1);
    }
  }, [compliance.length, previousComplianceLength, initialized]);

  return (
    <StyledBox>
      <UpdateBadge seenAt={updatedAt} updatedAt={latestDetection?.cardId && latestDetection?.date} disabled={index === 0} badgeContent={unseenDetections.length}>
        <ButtonBase onClick={() => { if (index !== 0) { setIndex(0); } }} className={clsx({ active: index === 0 })}>
          {t('right-panel.session-history.title')}
        </ButtonBase>
      </UpdateBadge>
      {!!compliance.length && (
        <ButtonBase onClick={() => { if (index !== 1) { setIndex(1); } }} className={clsx({ active: index === 1 })}>
          {t('right-panel.session-compliance.title')}
        </ButtonBase>
      )}
    </StyledBox>
  );
}
